var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"45"}})])}
var staticRenderFns = []

export { render, staticRenderFns }